// extracted by mini-css-extract-plugin
export var baseButton = "_pk-0";
export var controlsArrowKeys = "_pk-1";
export var controlsResetButton = "_pk-2";
export var lightGameButton = "_pk-4 _pk-0";
export var playAgainButton = "_pk-5 _pk-0";
export var startGameButton = "_pk-3 _pk-0";